/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

import { createSelector } from 'reselect';
import { hasPermission } from '../../entities/selectors';
import { getCurrentPermissions } from '../../userData/selectors';

const selectInteractionManagementMap = (state) => state.get('InteractionManagement');

export const selectInteractionManagementTableData = createSelector(selectInteractionManagementMap, (subState) =>
  subState.get('data')
);
export const selectInteractionManagementSorted = createSelector(selectInteractionManagementMap, (subState) =>
  subState.get('sorted')
);
export const selectInteractionManagementExpanded = createSelector(selectInteractionManagementMap, (subState) =>
  subState.get('expanded')
);
export const selectInteractionManagementSelected = createSelector(selectInteractionManagementMap, (subState) =>
  subState.get('selected')
);

export const getBulkSelected = createSelector(selectInteractionManagementMap, (subState) => subState.get('BulkSelected'));